import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue";
  import { QInput, ValidationRule } from "quasar";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: null
    },
    append: {
      type: String,
      default: null
    },
    bgColour: {
      type: String,
      default: "tw-white"
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue',
    'blur'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const rules = computed(() => [
    (val: number) => (props.required && (val || val == 0)) || !props.required || "Required",
    (val: number) => (val >= props.min) || `Must be greater than or equal to ${props.min}`,
    (val: number) => !props.max || (props.max !== null && val <= props.max) || `Must be less than ${props.max.toLocaleString()}`
  ] as ValidationRule[])

  const value = computed<number | null>({
    get() {
      return props.modelValue
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit
  
  const currencyInputRef = ref<QInput | null>(null);
  
  function validate() {
    const valid = currencyInputRef.value!.validate();
    return valid;
  }

  function resetValidation() {
    currencyInputRef.value?.resetValidation();
  }

  __expose({
    validate,
    resetValidation
  })

  function onBlur(event: Event) {
    if ((event.target! as HTMLInputElement).value === "") {
      emit('update:modelValue', props.min != null && props.min != undefined && props.required ? 0 : '')
    }
    emit('blur');
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QInput), {
      outlined: "",
      dense: "",
      ref_key: "currencyInputRef",
      ref: currencyInputRef,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      modelModifiers: { number: true },
      pattern: "[0-9]",
      required: __props.required,
      onBlur: onBlur,
      min: __props.min > 0 ? __props.min : __props.required ? 0 : null,
      max: __props.max,
      type: "number",
      "hide-spin-buttons": "",
      class: _normalizeClass([__props.bgColour, "tw-shadow-sm"]),
      "input-class": "tw-text-slate-500",
      placeholder: __props.placeholder,
      rules: rules.value,
      "lazy-rules": "",
      disable: __props.disable,
      clearable: __props.clearable,
      onWheel: _cache[1] || (_cache[1] = ($event: any) => ($event.target.blur())),
      "data-clarity-unmask": "true"
    }, _createSlots({ _: 2 }, [
      (__props.append)
        ? {
            name: "append",
            fn: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(__props.append), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "required", "min", "max", "class", "placeholder", "rules", "disable", "clearable"])
  ], 64))
}
}

})